import { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { useSearchParams } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import TableContainer from '../../../Components/Common/TableContainer';
import { PageHeader } from '../../../Components/Custom/PageHeader';
import { Pagination } from '../../../Components/Custom/pagination';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { paramsForExport, setDocumentTitle } from '../../../helpers/helpers';
import { getColumns } from './columns';
import { Filters } from './filters';
import { getShadowRanking } from './slice';
import { CsvExport } from '../../../Components/Custom/CsvExport';
import { AddShadowBalance } from './addShadowBalance';

const PAGE_TITLE = 'Shadow Ranking';

const INITIAL_PARAMS: {
  sortBy: string;
  sortOrder: string;
  countPerPage: string;
  numberOfPage: string;
} = {
  sortBy: 'id',
  sortOrder: 'DESC',
  countPerPage: '10',
  numberOfPage: '1'
};

const ShadowRankingPage = () => {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams(INITIAL_PARAMS);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { loading, data, totalCount } = useAppSelector(
    (state) => state.shadowRanking
  );

  useEffect(() => {
    dispatch(getShadowRanking(searchParams));
  }, [searchParams]);

  setDocumentTitle(PAGE_TITLE);

  const tableColumns = useMemo(
    () =>
      getColumns({
        onEdit: (row: any) => {
          setSearchParams((prevParams: URLSearchParams) => {
            prevParams.set('userId', String(row?.userId));
            return prevParams;
          });
          setIsOpen(true);
        }
      }),
    []
  );

  return (
    <div className='page-content'>
      <Container fluid>
        <BreadCrumb title={PAGE_TITLE} pageTitle='Dashboard' />
        <Row>
          <Col lg={12}>
            <Card id='orderList'>
              <PageHeader
                loading={loading}
                initialParams={INITIAL_PARAMS}
                setSearchParams={setSearchParams}
                title={PAGE_TITLE}
                actions={
                  <div>
                    <AddShadowBalance
                      params={searchParams}
                      searchParams={setSearchParams}
                      setIsOpen={setIsOpen}
                      isOpen={isOpen}
                    />
                  </div>
                }
              />

              <CardBody className='pt-0'>
                <Filters params={searchParams} setParams={setSearchParams} />

                <TableContainer
                  columns={tableColumns || []}
                  data={data}
                  divClass='table-responsive table-card mb-1'
                  tableClass='align-middle table-nowrap'
                  theadClass='table-light text-muted'
                />

                <Pagination
                  totalCount={totalCount}
                  data={data}
                  params={searchParams}
                  setParams={setSearchParams}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ShadowRankingPage;
